(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function init(root) {
    if (!root || root.getAttribute('data-az-ready') === 'true') return;

    var slides = toArray(root.querySelectorAll('[data-az-slide]'));
    var dots = toArray(root.querySelectorAll('[data-az-dot]'));
    var prev = root.querySelector('[data-az-prev]');
    var next = root.querySelector('[data-az-next]');
    var status = root.querySelector('[data-az-status]');
    var bar = root.querySelector('[data-az-bar]');
    if (slides.length === 0) return;

    root.setAttribute('data-az-ready', 'true');

    var delay = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var designMode = window.Shopify && window.Shopify.designMode;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && slides.length > 1 && !reduceMotion && !designMode;
    var index = 0;
    var timer = null;
    var hovering = false;
    var hidden = document.hidden;

    function setBar(running) {
      if (!bar) return;
      bar.style.transition = 'none';
      bar.style.transform = 'scaleX(0)';
      if (!running) return;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          bar.style.transition = 'transform ' + delay + 'ms linear';
          bar.style.transform = 'scaleX(1)';
        });
      });
    }

    function show(nextIndex, user) {
      if (nextIndex < 0) nextIndex = slides.length - 1;
      if (nextIndex >= slides.length) nextIndex = 0;
      index = nextIndex;

      for (var i = 0; i < slides.length; i++) {
        var on = i === index;
        slides[i].classList.toggle('is-active', on);
        slides[i].setAttribute('aria-hidden', on ? 'false' : 'true');
        if (dots[i]) {
          dots[i].classList.toggle('is-active', on);
          dots[i].setAttribute('aria-current', on ? 'true' : 'false');
        }
      }

      if (status) status.textContent = String(index + 1) + ' / ' + String(slides.length);
      if (autoplay && !user) setBar(true);
      else if (user) setBar(autoplay && !hovering && !hidden);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
      if (bar) {
        bar.style.transition = 'none';
        bar.style.transform = 'scaleX(0)';
      }
    }

    function start() {
      stop();
      if (!autoplay || hovering || hidden || slides.length < 2) return;
      setBar(true);
      timer = window.setInterval(function () {
        show(index + 1, false);
      }, delay);
    }

    function go(nextIndex) {
      show(nextIndex, true);
      start();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        go(index - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        go(index + 1);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        go(i);
      });
    });

    root.addEventListener('mouseenter', function () {
      hovering = true;
      stop();
    });

    root.addEventListener('mouseleave', function () {
      hovering = false;
      start();
    });

    root.addEventListener('focusin', function () {
      hovering = true;
      stop();
    });

    root.addEventListener('focusout', function (event) {
      if (root.contains(event.relatedTarget)) return;
      hovering = false;
      start();
    });

    function onVisibility() {
      hidden = document.hidden;
      if (hidden) stop();
      else start();
    }

    document.addEventListener('visibilitychange', onVisibility);

    root._azGo = go;
    root._azTeardown = function () {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
      root.setAttribute('data-az-ready', 'false');
    };

    show(0, true);
    start();
  }

  function boot(scope) {
    var nodes = (scope || document).querySelectorAll('[data-az-reviews]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var nodes = event.target.querySelectorAll('[data-az-reviews]');
    for (var i = 0; i < nodes.length; i++) {
      if (typeof nodes[i]._azTeardown === 'function') nodes[i]._azTeardown();
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target;
    if (!slide || !slide.hasAttribute || !slide.hasAttribute('data-az-slide')) {
      slide = event.target.closest ? event.target.closest('[data-az-slide]') : null;
    }
    if (!slide) return;
    var root = slide.closest('[data-az-reviews]');
    if (!root || typeof root._azGo !== 'function') return;
    var slides = root.querySelectorAll('[data-az-slide]');
    var index = Array.prototype.indexOf.call(slides, slide);
    if (index >= 0) root._azGo(index);
  });
})();
